import { useAnalyticsDataContext } from '../context/AnalyticsDataContext';

export const useAnalyticsData = () => useAnalyticsDataContext();
